import { Routes } from '@angular/router';
import { ScriptNames } from './modules/shared/enum/schema';
import { StoreRegionService } from './modules/shared/services/store-region.service';
import { StoreDetailService } from './modules/shared/services/resolver/store-detail.service';
import { ExchangeResolverService } from './modules/shared/services/resolver/exchange-resolver.service';
import { StoreGroupResolverResolver } from './modules/shared/services/resolver/store-group-resolver.resolver';
import { WalletBalanceService } from './modules/shared/services/resolver/wallet-balance.service';
import { RedirectGuard } from './modules/shared/guards/redirect.guard';
import { AuthGuard } from './modules/shared/guards/auth.guard';
import { AccessDeniedGuard } from './modules/shared/guards/access-denied.guard';
import { ClubMemberGuard } from './modules/shared/guards/club-member.guard';
import { productResolver } from './modules/shared/resolvers/products.resolver';
import { categoryResolver } from './modules/category/resolvers/category.resolver';
import { homepageResolver } from './modules/components/home/resolvers/homepage.resolver';
import {
  categoryRegionUrlGuard,
  homeRegionUrlGuard
} from './modules/shared/guards/region-url.guard';

export const routes: Routes = [
  {
    path: 'not-found',
    loadComponent: () =>
      import('./modules/components/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      )
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('./modules/components/access-denied/access-denied.component').then(
        (m) => m.AccessDeniedComponent
      ),
    canActivate: [AccessDeniedGuard]
  },
  {
    path: 'unsubscribe',
    loadComponent: () =>
      import('./modules/components/unsubscribe/unsubscribe.component').then(
        (m) => m.UnsubscribeComponent
      )
  },
  {
    path: 'feedback',
    loadComponent: () =>
      import('./modules/components/feedback/feedback.component').then(
        (m) => m.FeedbackComponent
      )
  },
  {
    path: 'landing/kingclub',
    loadComponent: () =>
      import('./modules/landing-pages/club/landing-page.component').then(
        (m) => m.ClubLandingPageComponent
      ),
    canActivate: [ClubMemberGuard, RedirectGuard],
    resolve: {
      storeRegion: StoreRegionService
    }
  },
  {
    path: 'landing/affiliate',
    loadComponent: () =>
      import('./modules/landing-pages/affiliate/landing-page.component').then(
        (m) => m.AffiliateLandingPageComponent
      ),
    canActivate: [RedirectGuard],
    resolve: {
      storeRegion: StoreRegionService
    }
  },
  {
    path: 'authenticate',
    loadChildren: () =>
      import('./modules/authenticate/authenticate.routes').then((m) => m.AUTHENTICATE_ROUTES)
  },
  {
    path: '',
    loadComponent: () =>
      import('./modules/components/wrapper/wrapper.component').then(
        (m) => m.WrapperComponent
      ),
    canActivateChild: [RedirectGuard],
    resolve: {
      storeRegion: StoreRegionService,
      storeDetail: StoreDetailService,
      storeGroup: StoreGroupResolverResolver
    },
        // children: [
          // {
            // path: '',
            // resolve: {
            //   profile: ProfileResolverService
            // },
            children: [
              {
                path: '',
                canActivate: [homeRegionUrlGuard, RedirectGuard],
                pathMatch: 'full',
                data: {
                  seoScript: ScriptNames.website
                },
                loadComponent: () =>
                  import('./modules/components/home/home.component').then(
                    (m) => m.HomeComponent
                  )
              },
              {
                path: 'pages/:page',
                loadComponent: () =>
                  import('./modules/components/static/static.component').then(
                    (m) => m.StaticComponent
                  ),
                resolve: {
                  storeDetail: StoreDetailService
                },
                canActivate: [RedirectGuard]
              },
              {
                path: 'search',
                canActivateChild: [RedirectGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./modules/components/search/search.component').then(
                        (m) => m.SearchComponent
                      )
                  }
                ]
              },
              {
                path: 'product/:id/:name',
                loadComponent: () =>
                  import('./modules/product/components/product-details/product-details.component').then(
                    (m) => m.productDetailsComponent
                  ),
                resolve: {
                  exchange: ExchangeResolverService,
                  walletBalance: WalletBalanceService,
                  productDetail: productResolver
                },
                canActivate: [RedirectGuard]
              },
              {
                path: 'product/:id',
                loadComponent: () =>
                  import('./modules/product/components/product-details/product-details.component').then(
                    (m) => m.productDetailsComponent
                  ),
                resolve: {
                  productDetail: productResolver
                }
              },
              {
                path: 'payment',
                loadComponent: () =>
                  import('./modules/product/components/payment-status/payment-status.component').then(
                    (m) => m.PaymentStatusComponent
                  ),
                canActivate: [AuthGuard, RedirectGuard],
                resolve: {
                  walletBalance: WalletBalanceService
                }
              },
              {
                path: 'checkout',
                loadComponent: () =>
                  import('./modules/product/components/payment/payment.component').then(
                    (m) => m.PaymentComponent
                  ),
                canActivate: [AuthGuard, RedirectGuard],
                resolve: {
                  walletBalance: WalletBalanceService
                }
              },
              {
                path: 'profile',
                loadComponent: () =>
                  import('./modules/profile/profile/profile.component').then(
                    (m) => m.ProfileComponent
                  ),
                canActivate: [AuthGuard, RedirectGuard],
                resolve: {
                  walletBalance: WalletBalanceService
                },
                children: [
                  {
                    path: 'edit',
                    loadComponent: () =>
                      import('./modules/profile/edit-profile/edit-profile.component').then(
                        (m) => m.EditProfileComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  },
                  {
                    path: 'wishlist',
                    loadComponent: () =>
                      import('./modules/profile/wish-list/wish-list.component').then(
                        (m) => m.WishListComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  },
                  {
                    path: 'wallet',
                    loadComponent: () =>
                      import('./modules/profile/wallet/wallet.component').then(
                        (m) => m.WalletComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  },
                  {
                    path: 'wallet/charge',
                    loadComponent: () =>
                      import('./modules/profile/charge-wallet-sheet/charge-wallet-sheet.component').then(
                        (m) => m.ChargeWalletSheetComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  },
                  {
                    path: 'order-history',
                    loadComponent: () =>
                      import('./modules/profile/shop-summary/shop-summary.component').then(
                        (m) => m.ShopSummaryComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  },
                  {
                    path: 'affiliate',
                    loadComponent: () =>
                      import('./modules/profile/affiliate-tab/affiliate-tab.component').then(
                        (m) => m.AffiliateTabComponent
                      ),
                    pathMatch: 'full',
                    canActivate: [AuthGuard]
                  }
                ]
              },
              {
                path: 'crypto',
                loadChildren: () =>
                  import('./modules/cryptopay/cryptopay.routes').then((m) => m.CRYPTOPAY_ROUTES)
              },
              {
                path: 'kingclub',
                loadChildren: () =>
                  import('./modules/king-club/king-club.routes').then((m) => m.KING_CLUB_ROUTES)
              },
              {
                path: 'category/list',
                loadComponent: () =>
                  import('./modules/category/components/category-list/category-list.component').then(
                    (m) => m.CategoryListComponent
                  )
              },

              {
                path: 'category/:countryCode/all',
                canActivate: [categoryRegionUrlGuard],
                loadComponent: () =>
                  import('./modules/category/components/category/category.component').then(
                    (m) => m.CategoryComponent
                  ),
                resolve: { categoryData: categoryResolver }
              },

              {
                path: 'category/:countryCode/:id/:name',
                canActivate: [categoryRegionUrlGuard],
                loadComponent: () =>
                  import('./modules/category/components/category/category.component').then(
                    (m) => m.CategoryComponent
                  ),
                resolve: { categoryData: categoryResolver }
              },
              {
                path: 'category/:countryCode',
                pathMatch: 'full',
                redirectTo: '/category/:countryCode/all'
              },
              {
                path: ':countryCode',
                canActivate: [homeRegionUrlGuard, RedirectGuard],
                data: {
                  seoScript: ScriptNames.website
                },
                resolve: {
                  homepage: homepageResolver
                },
                loadComponent: () =>
                  import('./modules/components/home/home.component').then(
                    (m) => m.HomeComponent
                  )
              }
            ]
          // }
        // ]

  },
  {
    path: '**',
    redirectTo: 'not-found',
    pathMatch: 'full'
  }
];
